@use '@design/components/custom-scroll/custom-scroll' as *;

.root {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  @include custom-scroll-minimal;
}
